import React, { useState } from 'react';

// material UI
import CircularProgress from '@mui/material/CircularProgress';

// theme
import aampeTheme from '../../constants/aampeTheme';

// components
import AampeTooltip, {
    TooltipPlacement,
} from '../shared/AampeTooltip/AampeTooltip';

interface IconButtonProps {
    Icon: any;
    isLoading?: boolean;
    tooltip?: string;
    action: (e?: MouseEvent) => void;
    color?: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    size?: number;
    tooltipPlacement?: TooltipPlacement;
}

const IconButton: React.FC<React.PropsWithChildren<IconButtonProps>> = ({
    Icon,
    isLoading,
    tooltip = '',
    action,
    color = aampeTheme.colors.solidA01,
    disabled = false,
    style,
    size,
    tooltipPlacement,
}) => {
    const [hover, setHover] = useState<boolean>(false);
    const handleClick = !disabled ? action : null;

    return (
        <>
            {isLoading ? (
                <CircularProgress size={24} />
            ) : (
                <AampeTooltip title={tooltip} placement={tooltipPlacement}>
                    <div>
                        <Icon
                            onClick={handleClick}
                            onMouseEnter={() => {
                                setHover(true);
                            }}
                            onMouseLeave={() => {
                                setHover(false);
                            }}
                            size={size}
                            style={{
                                ...style,
                                color: disabled
                                    ? 'lightgray'
                                    : hover
                                    ? aampeTheme.colors.solidA01
                                    : color,
                                cursor: disabled ? 'not-allowed' : 'pointer',
                            }}
                        />
                    </div>
                </AampeTooltip>
            )}
        </>
    );
};

export default React.memo(IconButton);
